import React from 'react'
import { Progress } from "./ProgressBar.style"

const ProgressBar = (props:any) => {
    return (
        <Progress variant="determinate" value={props.value} />
    )
}

export default ProgressBar
